import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	toLabel: {
		id: 'admin-pages-contact-administrator.contact-admin-form.to-label',
		defaultMessage: 'To',
		description: 'Field label for email reciepient',
	},
	toValue: {
		id: 'admin-pages-contact-administrator.contact-admin-form.to-value',
		defaultMessage: 'Jira administrator',
		description: 'Field value for email reciepient',
	},
	fromLabel: {
		id: 'admin-pages-contact-administrator.contact-admin-form.from-label',
		defaultMessage: 'From',
		description: 'Field label for email sender',
	},
	subjectLabel: {
		id: 'admin-pages-contact-administrator.contact-admin-form.subject-label',
		defaultMessage: 'Subject',
		description: 'Field label for subject of mail',
	},
	detailsLabel: {
		id: 'admin-pages-contact-administrator.contact-admin-form.details-label',
		defaultMessage: 'Request details',
		description: 'Field label for request details of mail',
	},
	errorMessageToLarge: {
		id: 'admin-pages-contact-administrator.contact-admin-form.error-message-to-large',
		defaultMessage: 'You’ve exceeded the character limit for the subject.',
		description: 'The test for the field is to large',
	},
	errorMessageEmailNotValid: {
		id: 'admin-pages-contact-administrator.contact-admin-form.error-message-email-not-valid',
		defaultMessage: 'Enter a valid email address',
		description: 'Email is not valid',
	},
	errorMessageCouldNotSendMail: {
		id: 'admin-pages-contact-administrator.contact-admin-form.error-message-could-not-send-mail',
		defaultMessage: "We couldn't send the email. Try again in some time ",
		description: 'Mail could not be sent',
	},
	successMessageMailSent: {
		id: 'admin-pages-contact-administrator.contact-admin-form.success-message-mail-sent',
		defaultMessage: 'We’ve reached out to your Jira administrator.',
		description: 'Mail has been sent to the administrator',
	},
});
